import { gridItemClasses } from "../../projects-and-folders/WorkspaceBodyProjectsAndFolders"
import { WorkspaceHomeGetMoreSection } from "../components/sections/WorkspaceHomeGetMoreSection"
import { WorkspaceHomeLearnSection } from "../components/sections/WorkspaceHomeLearnSection"
import { WorkspaceProjectCard } from "../../projects-and-folders/grid-view/WorkspaceProjectCard"
import { useMemo } from "react"
import { WorkspaceHomeSectionTitle } from "../components/WorkspaceHomeSectionTitle"
import { useWorkspaceBodyContent } from "features/data-management/workspace/context/useWorkspaceBodyContent"
import { useAppSelector } from "integrations/redux/hooks"
import { selectAllFires } from "features/entity-caching/fires/selectors"
import { ButtonTertiary } from "@nova/component-btn"
import { useRouter } from "pages"
import * as Icons from "@nova/component-icons"

const MAX_RECENTS = 8

export const WorkspaceHomeBodyReturningUser = () => {
    const { bodyProjectIds, activeProjectIds } = useWorkspaceBodyContent()
    const allProjectsById = useAppSelector(selectAllFires)
    const isFirstLogin = sessionStorage.getItem("isFirstLogin") === "true"
    const router = useRouter("/workspace/:workspaceId")

    const trimmedBodyProjectIds = useMemo(
        () => bodyProjectIds.slice(0, MAX_RECENTS),
        [bodyProjectIds]
    )
    const trimmedActiveProjectIds = useMemo(() => activeProjectIds.slice(0, 4), [activeProjectIds])

    return (
        <>
            <div className="mt-8 w-full flex flex-col gap-8">
                {/* Recents Section */}
                {trimmedBodyProjectIds.length > 0 && (
                    <div>
                        <WorkspaceHomeSectionTitle
                            title="Pick up where you left off"
                            shouldShowBorder={false}
                            action={
                                bodyProjectIds.length > MAX_RECENTS && (
                                    <ButtonTertiary
                                        onClick={() => router.navigate({ path: "/explore" })}
                                        title={"See more recents"}
                                        RightIcon={Icons.ArrowRight}
                                    />
                                )
                            }
                        />
                        <div className={gridItemClasses}>
                            {trimmedBodyProjectIds.map((projectId, i) => {
                                const project = allProjectsById[projectId]
                                if (!project) return null
                                return <WorkspaceProjectCard key={i} project={project} />
                            })}
                        </div>
                    </div>
                )}

                {/* Active Section */}
                {trimmedActiveProjectIds.length > 0 && (
                    <div>
                        <WorkspaceHomeSectionTitle
                            title="Join an active project"
                            shouldShowBorder={false}
                        />
                        <div className={gridItemClasses}>
                            {trimmedActiveProjectIds.map((projectId, i) => {
                                const project = allProjectsById[projectId]
                                if (!project) return null
                                return <WorkspaceProjectCard key={i} project={project} />
                            })}
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col xl:flex-row gap-0 xl:gap-12">
                {/* Secondary/Learn Section */}
                <WorkspaceHomeLearnSection style={{ flex: "1 1" }} />

                {/* Tertiary / Get More Section */}
                <WorkspaceHomeGetMoreSection
                    style={{ flex: "1 0.33" }}
                    className="mb-12 xl:mb-0"
                    isFirstLogin={isFirstLogin}
                />
            </div>
        </>
    )
}
